
import React from 'react';
import DiscountSection from './DiscountSection';
import CouponSection from './CouponSection';
import { UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

interface PromotionSectionProps {
  form: UseFormReturn<z.infer<any>>;
  applyDiscount: boolean;
  setApplyDiscount: React.Dispatch<React.SetStateAction<boolean>>;
  applyCoupon: boolean;
  setApplyCoupon: React.Dispatch<React.SetStateAction<boolean>>;
}

const PromotionSection: React.FC<PromotionSectionProps> = ({
  form,
  applyDiscount,
  setApplyDiscount,
  applyCoupon,
  setApplyCoupon,
}) => {
  return (
    <div className="space-y-4 border-t pt-4">
      <DiscountSection 
        form={form}
        applyDiscount={applyDiscount}
        setApplyDiscount={setApplyDiscount}
      />
      
      <CouponSection 
        form={form}
        applyCoupon={applyCoupon}
        setApplyCoupon={setApplyCoupon}
      />
    </div>
  );
};

export default PromotionSection;
